import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { dateFilters } from '@/constants/date'
import { DateFilterEnum } from '@/enums'

import { PersonalizationEngineModels } from '../'
import {
  getAllPersonalizationEngineExtraReducer,
  getFavoriteGamesExtraReducer,
} from './'

export const personalizationInitialState: PersonalizationEngineModels.PersonalizationEngineState =
  {
    filters: {
      reportType: 2,
      limit: 25,
      page: 1,
      startDate: dateFilters[DateFilterEnum.LAST_7_DAYS].dateStart,
      endDate: dateFilters[DateFilterEnum.LAST_7_DAYS].dateEnd,
    },
    gameCategory: [],
    gameProvider: [],
    favoriteGames: [],
    isLoadingGameCategory: false,
    isLoadingGameProvider: false,
    isLoadingFavoriteGames: false,
    pagination: {
      total: 0,
      limit: 25,
      page: 1,
      pages: 1,
    },
  }

export const personalizationSlice = createSlice({
  name: 'personalizationEngine',
  initialState: personalizationInitialState,
  reducers: {
    setPersonalizationFiltersAction: (
      state,
      action: PayloadAction<PersonalizationEngineModels.PersonalizationEngineFiltersType>,
    ) => {
      state.filters = action.payload
    },
    resetPersonalizationDataAction: (state) => {
      state.gameCategory = []
      state.gameProvider = []
      state.favoriteGames = []
    },
  },
  extraReducers: (builder) => {
    getAllPersonalizationEngineExtraReducer(builder)
    getFavoriteGamesExtraReducer(builder)
  },
})

export const PersonalizationEngineActions = personalizationSlice.actions
